import React, { useState, useMemo } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  ListSubheader,
  TextField,
  InputAdornment,
  Grid,
  Typography,
  InputLabel,
  
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ReactCountryFlag from "react-country-flag";
import useStyles from './styles.js'

const containsText = (text, searchText) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

/* const allOptions = ["Option One", "Option Two", "Option Three", "Option Four"];
 */
export default function CountrySelect({allOptions,defaultOption,onChange,Label,required,openCountrySelect,setOpenCountrySelect,t, handleFocus,handleBlur}) {
  const [selectedOption, setSelectedOption] = useState(allOptions[0]);
  const selectRef = React.useRef(null)
  const [searchText, setSearchText] = useState("");
  const displayedOptions = useMemo(
    () => allOptions.filter((option) => containsText(option.name, searchText)),
    [allOptions, searchText]
  );
  const classes = useStyles()

 
  const handleOnchange =(e)=>{
    setSelectedOption(e.target.value)
    onChange(e)
  }


  //handleClick(selectRef)
  return (
    <Box sx={{ p: 5 ,width:'100%'}}>
   
      <FormControl fullWidth>
      
{/*         <InputLabel id="search-select-label">{Label}</InputLabel>
 */}        <Select className={classes.cselect}
        
          ref={selectRef}
          open={openCountrySelect}
          onClose={() => {setOpenCountrySelect(false);setSearchText("")}}
          onOpen={() =>  setOpenCountrySelect(true)}
          onFocus={()=>{handleFocus()}}
          onBlur={()=>{handleBlur()}}
          // Disables auto focus on MenuItems and allows TextField to be in focus
          MenuProps={{ autoFocus: false }}
          labelId="search-select-label"
          id="search-select"
          value={selectedOption}
          defaultValue={defaultOption}
          label={Label}
          variant="standard"
          required={required}
          fullWidth
          onChange={(e) => handleOnchange(e)}
         // onClose={() => setSearchText("")}
          // This prevents rendering empty string in Select's value
          // if search text would exclude currently selected option.
          //renderValue={() => selectedOption}
        >
          {/* TextField is put into ListSubheader so that it doesn't
              act as a selectable item in the menu
              i.e. we can click the TextField without triggering any selection.*/}
          <ListSubheader>
          <Grid container justifyContent={'center'} alignItems={'center'} padding={2}>
    <Grid item >
     <Typography variant="h6" fontSize={'0.8rem'}>
    {t("countrychoice.prompt")}
     </Typography>
    </Grid>
  </Grid>
            <TextField
              size="small"
              // Autofocus on textfield
              autoFocus
              placeholder={t("countrychoice.countryscope_select")}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
         {/*  <MenuItem key={0} value={t("countrychoice.all")}>
              {'All'}
            </MenuItem> */}
          {displayedOptions.map((option, i) => (
            <MenuItem key={`menu-item-${i}`} value={option}>
              <Grid container>
                <Grid item xs={2}> <ReactCountryFlag countryCode={option.iso2} svg
                         
                         style={{
                          width: '1em',
                          height: '1em',
                      }}/></Grid> 
                <Grid item xs={10} > {option.name}</Grid>
              </Grid>
             
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
